/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Detail_History_TitleInputs */

const vi_product_lot_detail_history_title = /** @type {(inputs: Product_Lot_Detail_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch sử giao dịch`)
};

/**

* @param {Product_Lot_Detail_History_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_detail_history_title = /** @type {((inputs?: Product_Lot_Detail_History_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Detail_History_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_detail_history_title(inputs)
});